const settingsEn = {
    action: require('../../lang/en/settings/Action').default,
    module: require('../../lang/en/settings/Module').default,
    permission: require('../../lang/en/settings/Permission').default,
    userRole: require('../../lang/en/settings/UserRole').default,
};

export default settingsEn;